import { FC, LegacyRef } from 'react';
import { Button, Flex } from '@highereducation/hen-ui';
import { BsCheckCircleFill, BsXCircleFill } from 'react-icons/bs';
import { QuestionProps } from '@de/components/Step/Step';
import { useDynamicExperienceContext } from '@de/providers/DynamicExperienceProvider';
import useQuestionEvents from '@de/hooks/useQuestionEvents';

const Toggle: FC<QuestionProps> = ({
  options = [],
  id = '',
  leadFieldAssociated,
  automaticNext = false,
  isMultiQuestionChild = false,
  title,
  stepName,
  variant,
}) => {
  const { updateFlowState, getStepMetadataById, handleStepForward } =
    useDynamicExperienceContext();
  const stepSelectedData = getStepMetadataById(id || '');
  const selectedOption = stepSelectedData?.option;

  const iconMap = {
    yes: (
      <BsCheckCircleFill className='w-[14px] h-[14px] !block !text-[rgb(34,197,94)]' />
    ),
    no: (
      <BsXCircleFill className='w-[14px] h-[14px] !block !text-[rgb(239,68,68)]' />
    ),
  };

  const { ref: visibilityRef, triggerFieldInputted } = useQuestionEvents({
    id,
    fieldType: 'toggle',
    options,
    title,
    stepName,
    isMultiQuestionChild,
    variant,
    leadFieldAssociated,
  });

  return (
    <Flex
      gap='sm'
      wrap='wrap'
      align='center'
      direction='row'
      justify='start'
      className='font-normal w-full'
      ref={visibilityRef as LegacyRef<HTMLDivElement>}
    >
      {options.map((option, index) => {
        const isSelected =
          selectedOption &&
          !Array.isArray(selectedOption) &&
          selectedOption?.optionId === option?.optionId;
        return (
          <Button
            key={index}
            size='sm'
            variant='grayOutline'
            aria-pressed={isSelected}
            className='w-fit'
            onClick={() => {
              if (isSelected) {
                updateFlowState(id, {});
              } else {
                updateFlowState(id, { option, leadFieldAssociated });
              }
              triggerFieldInputted(option.text as string);

              if (automaticNext && !isMultiQuestionChild) {
                handleStepForward();
              }
            }}
          >
            {iconMap[option?.text?.toLowerCase() as keyof typeof iconMap]}
            {option.text}
          </Button>
        );
      })}
    </Flex>
  );
};

export default Toggle;
